import React, { memo, useState } from 'react';

import { TooltipContent, TooltipItem, type TooltipProps, TooltipTrigger } from '@pkg/components';

export function TooltipComponent({
    children,
    trigger,
    variant,
    controlled = false,
    maxWidth,
    ...options
}: TooltipProps) {
    const [open, setOpen] = useState(false);

    const Uncontrolled = () => (
        <TooltipItem {...options}>
            <TooltipTrigger>{trigger}</TooltipTrigger>
            <TooltipContent variant={variant} maxWidth={maxWidth}>
                {children}
            </TooltipContent>
        </TooltipItem>
    );

    const Controlled = () => (
        <TooltipItem open={open} onOpenChange={setOpen} {...options}>
            <TooltipTrigger onClick={() => setOpen((v) => !v)}>{trigger}</TooltipTrigger>
            <TooltipContent variant={variant} maxWidth={maxWidth}>
                {children}
            </TooltipContent>
        </TooltipItem>
    );

    return controlled ? <Controlled /> : <Uncontrolled />;
}

export const Tooltip = memo(TooltipComponent);
